export default "/images/b5dda70c5a815fa8b965703d32070516.avif";